/**
 * DissolveGroupButton — opens the dissolve confirmation dialog.
 * Only renders if user has canDissolve permission.
 */

import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DissolveGroupDialog } from './DissolveGroupDialog';
import type { BuddyGroupSummary, BuddyGroupDetail } from '../types/buddy-group';

interface DissolveGroupButtonProps {
  group: BuddyGroupSummary | BuddyGroupDetail;
  onDissolved: () => void;
}

export function DissolveGroupButton({ group, onDissolved }: DissolveGroupButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="destructive" size="sm" onClick={() => setOpen(true)}>
        <Trash2 className="h-4 w-4 mr-1" /> Dissolve
      </Button>
      {open && (
        <DissolveGroupDialog
          group={group}
          open={open}
          onClose={() => setOpen(false)}
          onDissolved={() => {
            setOpen(false);
            onDissolved();
          }}
        />
      )}
    </>
  );
}
